/**
 * Accordion Media: one item open at a time (across all groups); the side image follows the open item.
 * Buttons carry aria-expanded; panels use [hidden]. Closing the open item keeps its image.
 */
(() => {
  const init = (root) => {
    const items = Array.from(root.querySelectorAll('[data-accordion-media-item]'));
    const figures = Array.from(root.querySelectorAll('[data-accordion-media-figure]'));

    const setOpen = (item, open) => {
      const toggle = item.querySelector('[data-accordion-media-toggle]');
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      item.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) {
        panel.hidden = !open;
      }
    };

    items.forEach((item, index) => {
      item.querySelector('[data-accordion-media-toggle]')?.addEventListener('click', () => {
        const opening = !item.classList.contains('is-open');
        items.forEach((other) => setOpen(other, other === item && opening));
        if (opening) {
          figures.forEach((figure, i) => figure.classList.toggle('is-active', i === index));
        }
      });
    });
  };

  const boot = () => document.querySelectorAll('[data-accordion-media]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
